export { default } from './EzTable.vue';
